export const contact = {
  hero: {
    title: 'Kontakt',
    titleHighlight: 'BULKCOM',
    description: 'Spojte sa s našimi energetickými špecialistami, aby ste prediskutovali vaše požiadavky a objavili, ako môžeme optimalizovať vašu energetickú infraštruktúru so spoľahlivými a nákladovo efektívnymi riešeniami.'
  },
  info: {
    title: 'Kontaktujte nás',
    subtitle: 'Náš tím je pripravený pomôcť vám s vašimi energetickými potrebami',
    address: 'Adresa',
    addressValue: 'Gorkého 129/10, Bratislava – Staré Mesto',
    invoicing: 'Fakturačná adresa',
    invoicingValue: 'Poštová 3, Bratislava – Staré Mesto 811 06, Slovensko',
    email: 'E-mail'
  },
  form: {
    title: 'Pošlite nám správu',
    subtitle: 'Vyplňte formulár nižšie a ozveme sa vám do 24 hodín',
    name: 'Vaše meno',
    namePlaceholder: 'Ján Novák',
    email: 'Váš email',
    emailPlaceholder: 'jan@spolocnost.sk',
    company: 'Vaša spoločnosť',
    companyPlaceholder: 'Názov spoločnosti (Voliteľné)',
    message: 'Vaša správa',
    messagePlaceholder: 'Povedzte nám o vašich energetických požiadavkách...',
    charactersRemaining: 'zostávajúcich znakov',
    submit: 'Odoslať správu',
    sending: 'Odosiela sa...',
    successTitle: 'Správa úspešne odoslaná!',
    successMessage: 'Ďakujeme, že ste nás kontaktovali. Ozveme sa vám do 24 hodín.',
    errorTitle: 'Chyba pri odosielaní správy',
    errorMessage: 'Skúste to prosím znova alebo nás kontaktujte priamo na office@bulkcomsro.com',
    close: 'Zavrieť'
  }
};
